module.exports = __webpack_public_path__ + "img/booths_mobile.4d2b74ed.svg";